"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_prepare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "91c13b63-98b7-4cbc-af64-88a6260e84d3",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "prepare-hi"), /*#__PURE__*/React.createElement("rect", {
    x: 95.89,
    y: 32.18,
    width: 25.1,
    height: 149.89,
    rx: 6.77,
    ry: 6.77,
    transform: "translate(-43.99 108.06) rotate(-45)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.25,
    y1: 29.5,
    x2: 94.25,
    y2: 46.25,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86,
    y1: 37.87,
    x2: 102.5,
    y2: 37.87,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.06,
    y1: 106.4,
    x2: 58.06,
    y2: 138,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 122.2,
    x2: 73.62,
    y2: 122.2,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 60,
    r: 20,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132,78a20,20,0,0,1-20-19c0,.33,0,.66,0,1a20,20,0,0,0,40,0c0-.34,0-.67-.05-1A20,20,0,0,1,132,78Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 164.16,
    cy: 43.87,
    r: 4,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 76,
    r: 4,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 47.87,
    r: 8,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,54.5a8,8,0,0,1-8-7.31c0,.22,0,.45,0,.68a8,8,0,1,0,16,0c0-.23,0-.46,0-.68A8,8,0,0,1,32,54.5Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 83.87,
    cy: 147.87,
    r: 4,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11,50a6.79,6.79,0,0,0-9.57,0l-8.18,8.19a6.76,6.76,0,0,0,0,9.56L74.71,91.15,92.46,73.4Z",
    transform: "translate(0 0)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.53,146.47l-22.08-22.08L125.7,142.14l22.08,22.08a6.79,6.79,0,0,0,9.57,0l8.18-8.19A6.78,6.78,0,0,0,165.53,146.47Z",
    transform: "translate(0 0)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.53,153.9,156.41,163a5.45,5.45,0,0,1-7.68,0L51.36,65.66A6.68,6.68,0,0,1,49.48,62a6.75,6.75,0,0,0,1.88,5.84l96.42,96.43a6.79,6.79,0,0,0,9.57,0l8.18-8.19a6.77,6.77,0,0,0,1.89-5.85A6.69,6.69,0,0,1,165.53,153.9Z",
    transform: "translate(0 0)"
  })));
}

var _default = ic_prepare;
exports.default = _default;